import FinancialInformation from './FinancialInformation'

export default FinancialInformation
